"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

var Chart = require("chart.js");

exports.default = {
  props: ["data"],

  mounted: function mounted() {
    this.render();
  },


  methods: {
    render: function render() {
      var myChart = new Chart(this.$refs.canvas, {
        type: "horizontalBar",
        data: {
          labels: this.data.chartsData.labels,
          datasets: [{
            label: "",
            backgroundColor: this.data.chartsData.colors,
            data: this.data.chartsData["average"]
          }]
        },
        options: {
          legend: { display: false },
          title: {
            display: true,
            text: this.data.chartsData.name
          },
          scales: {
            xAxes: [{
              ticks: {
                suggestedMax: this.data.chartsData.questionMax,
                suggestedMin: this.data.chartsData.questionMin
              }
            }]
          }
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/elements/CompareReportIntervalChart.vue
// module id = OYRK
// module chunks = 0 1